import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../shared/auth/msalConfig";
import { T } from "../shared/styles/theme";

export default function LoginScreen() {
  const { instance, inProgress } = useMsal();
  const [h, setH] = useState(false);
  const [error, setError] = useState(null);
  const isLoading = inProgress !== InteractionStatus.None;

  const handleLogin = async () => {
    try {
      setError(null);
      await instance.loginPopup(loginRequest);
    } catch (e) {
      console.error("Login error:", e);
      if (e.errorCode === "popup_window_error") {
        try {
          await instance.loginRedirect(loginRequest);
        } catch {
          setError("Login failed. Please try again or contact IT.");
        }
      } else if (e.errorCode !== "user_cancelled") {
        setError(e.errorMessage || "Login failed. Please try again.");
      }
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: T.bg,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: `radial-gradient(ellipse at 30% 40%,rgba(0,103,171,0.06) 0%,transparent 60%),
                       radial-gradient(ellipse at 70% 70%,rgba(0,159,226,0.04) 0%,transparent 50%),
                       linear-gradient(180deg,${T.bg} 0%,#e9e9e9 100%)`,
        }}
      />
      <div
        className="login-card"
        style={{
          position: "relative",
          width: 420,
          padding: 48,
          background: T.surface,
          border: `1px solid ${T.border}`,
          borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <img
            src="/logos/vq-logo-dark.png"
            alt="ValueQuest"
            style={{ height: 52, width: "auto", marginBottom: 16 }}
          />
          <p style={{ fontSize: 13, color: T.muted, marginTop: 4 }}>
            Investment Advisors — Internal Portal
          </p>
        </div>

        <button
          onClick={handleLogin}
          disabled={isLoading}
          onMouseEnter={() => setH(true)}
          onMouseLeave={() => setH(false)}
          style={{
            width: "100%",
            padding: "14px 24px",
            border: "none",
            borderRadius: 10,
            background: h ? "#005a96" : T.primary,
            color: "#ffffff",
            fontSize: 14,
            fontWeight: 500,
            cursor: isLoading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            transition: "all 0.25s",
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          {isLoading ? (
            "Signing in..."
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 21 21">
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
              </svg>
              Sign in with Microsoft
            </>
          )}
        </button>

        {error && (
          <div
            style={{
              marginTop: 12,
              padding: "10px 14px",
              background: "rgba(192,57,43,0.06)",
              border: "1px solid rgba(192,57,43,0.15)",
              borderRadius: 8,
              fontSize: 12,
              color: T.red,
            }}
          >
            {error}
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            margin: "24px 0",
            color: T.muted,
            fontSize: 12,
          }}
        >
          <div style={{ flex: 1, height: 1, background: T.border }} />
          Secured by Azure AD
          <div style={{ flex: 1, height: 1, background: T.border }} />
        </div>
        <p style={{ textAlign: "center", fontSize: 12, color: T.muted }}>
          MFA enabled for all accounts.
        </p>
      </div>
    </div>
  );
}
